// @flow
import { call, put, takeEvery } from 'redux-saga/effects'
import { FETCH, locationsFetchSuccess, locationsFetchError } from './'

const getLocations = () => {
  const url = process.env.REACT_APP_LOCATIONS_GATEWAY || ''
  return fetch(url, {
    method: 'get'
  })
    .then(response => response.json())
    .then(json => json)
}

function* fetchLocationsWorker(action) {
  try {
    const data = yield call(getLocations)
    yield put(locationsFetchSuccess(data))
  } catch (error) {
    yield put(locationsFetchError(error))
  }
}

// $FlowFixMe
export function* fetchLocationsSaga() {
  // $FlowFixMe
  yield takeEvery(FETCH, fetchLocationsWorker)
}



// WEBPACK FOOTER //
// ./src/ducks/locations/saga.js